const RoundedIcon = ({src, alt, textHover, size})=> {
    return (
        <abbr title={textHover}>
            <img src={src} alt={alt} style={{width: size}} className="w-12"/>
        </abbr>
    )
}

export default RoundedIcon